"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Generated by CoffeeScript 1.12.2
var Share_Modal = void 0;

var url_to_array = void 0;

url_to_array = require("../helpers/url_to_array").default;

Share_Modal = function () {
  function Share_Modal() {
    var description = void 0;
    var encoded_url = void 0;
    var media = void 0;
    var modal_setup = void 0;
    var service = void 0;
    var url = void 0;
    url = $(".share").data("url");
    encoded_url = encodeURIComponent($(".share").data("url"));
    media = encodeURIComponent($(".share").data("media"));
    description = encodeURIComponent($(".share").data("description"));
    service = "";

    modal_setup = function modal_setup(href) {
      var height = void 0;
      var left = void 0;
      var opts = void 0;
      var setup_url = void 0;
      var top = void 0;
      var width = void 0;
      width = 575;
      height = 400;
      left = ($(window).width() - width) / 2;
      top = ($(window).height() - height) / 2;
      setup_url = href;
      opts = "status=1,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left;
      return window.open(setup_url, "", opts);
    };
    $(".share-on-facebook").on("click", function (e) {
      var $share_element = void 0;
      if (noun.share_element !== void 0) {
        $share_element = noun.share_element;
        url = "https://" + url_to_array[2] + $share_element.data("url");
      } else {
        url = $(".share").data("url");
      }
      service = "Facebook";
      e.preventDefault();
      this.href = "https://www.facebook.com/sharer/sharer.php";
      this.href += "?u=" + url;

      return modal_setup(this.href);
    });
    $(".share-on-twitter").on("click", function (e) {
      var $share_element = void 0;
      var new_url = void 0;
      service = "Twitter";
      e.preventDefault();
      if (noun.share_element !== void 0) {

        $share_element = noun.share_element;
        description = encodeURIComponent($share_element.data("description"));
        new_url = "https://" + url_to_array[2] + $share_element.data("url");
        this.href = "//twitter.com/share?text=" + description + encodeURIComponent(" on the @NounProject. ") + "&url=" + new_url;
      } else {

        description = encodeURIComponent($(".share").data("description"));
        new_url = encodeURIComponent($(".share").data("url"));
        this.href += "?text=" + description + encodeURIComponent(" on the @NounProject. ") + "&url=" + new_url;
      }

      return modal_setup(this.href);
    });
    $(".share-on-tumblr").on("click", function (e) {
      var $share_element = void 0;
      service = "Tumblr";
      e.preventDefault();
      if (noun.share_element !== void 0) {
        $share_element = noun.share_element;
        encoded_url = encodeURIComponent("https://www.thenounproject.com" + $share_element.data("url"));
        media = encodeURIComponent($share_element.data("media"));
        description = encodeURIComponent($share_element.data("description"));
        this.href = "//www.tumblr.com/share/photo";
        this.href += "?source=" + media;
        this.href += "&caption=" + description + encodeURIComponent(" on the @NounProject. ");
        this.href += "&click_thru=" + encoded_url;
      } else {
        encoded_url = encodeURIComponent($(".share").data("url"));
        media = encodeURIComponent($(".share").data("media"));
        description = encodeURIComponent($(".share").data("description"));
        this.href += "?source=" + media;
        this.href += "&caption=" + description;
        this.href += "&click_thru=" + encoded_url;
      }
      return modal_setup(this.href);
    });
    $("#share-on-pinterest").on("click", function (e) {
      var $share_element = void 0;
      service = "Pinterest";
      e.preventDefault();
      if (noun.share_element !== void 0) {
        $share_element = noun.share_element;
        url = "https://" + url_to_array[2] + $(".share").data("url");
        media = encodeURIComponent($share_element.data("media"));
        description = encodeURIComponent($share_element.data("description"));
        this.href += "?url=" + url + "&amp;media=" + media + "&amp;description=" + description;
      } else {
        url = $(".share").data("url");
        media = encodeURIComponent($(".share").data("media"));
        description = encodeURIComponent($(".share").data("description"));
        this.href += "?url=" + url + "&amp;media=" + media + "&amp;description=" + description;
      }
      return modal_setup(this.href);
    });
  }

  return Share_Modal;
}();

exports.default = Share_Modal();